import {Component, Inject, OnInit} from '@angular/core';
import {listOption, treePickerParams} from "./yz-tree-picker.service";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'yz-tree-picker',
  templateUrl: './yz-tree-picker.component.html',
  styleUrls: ['./yz-tree-picker.component.less']
})
export class YzTreePickerComponent implements OnInit {

  titleName: string = null;
  closeBtnText: string = null;
  pickerClassName: string = null;

  // 部门/班级
  deptNode: Array<listOption> = [];
  deptList = [];

  resultList = [];
  searchValue: string = null;
  searchResult = [];

  constructor(public dialogRef: MatDialogRef<YzTreePickerComponent>,
              @Inject(MAT_DIALOG_DATA) public data: treePickerParams) {
  }

  ngOnInit() {
    this.titleName = this.data.titleName;
    this.deptNode = this.data.tree;
    this.closeBtnText = this.data.closeBtnText;
    this.pickerClassName = this.data.pickerClassName;
    this.blTree(this.deptNode, null);
    this.setDefultValue();
    this.blTree(this.deptNode, null);
    this.dialogRef.backdropClick().subscribe(() => { // 点击背景遮罩层关闭选择器时
      document.getElementsByClassName('tree-picker-panel-bg')[0].remove();
      this.closeHandle()
    })
  }

  // 关闭
  closeHandle() {
    this.dialogRef.close(this.resultList);
  }

  // 重置
  resetHandle() {
    this.resultList = [];
    this.blTree(this.deptNode, null);
    this.deptList = this.deptNode.length > 0 ? this.deptNode : []
    this.cancelSearchHandle();
  }

  // 回显
  setDefultValue() {
    if (this.data.value) {
      this.resultList = this.familyTree(this.deptNode, this.data.value).reverse();
      if (this.resultList.length == 0) {
        console.error('传入参数中回显数据字段（value）值不存在于数据源中！！！');
        return
      }
      if (this.resultList[this.resultList.length - 1].children && this.resultList[this.resultList.length - 1].children.length > 0) {
        this.deptList = this.resultList[this.resultList.length - 1].children;
      } else if (this.resultList.length >= 2) {
        this.deptList = this.resultList[this.resultList.length - 2].children;
      } else {
        this.deptList = this.deptNode.length > 0 ? this.deptNode : [];
      }
    } else {
      this.deptList = this.deptNode.length > 0 ? this.deptNode : []
    }
  }

  // 遍历树节点，设置父id
  blTree(data, id) {
    if (data && data.length && data.length > 0) {
      data.forEach((item) => {
        item['pid'] = id;
        item['selected'] = this.resultList.some(item2 => item2.value == item.value);
        this.blTree(item.children, item.value)
      })
    }
  }


  // 递归获取子节点所有父节点
  familyTree(arr1, id) {
    let temp = []
    const forFn = function (arr, id) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        if (item.value === id) {
          temp.push(item)
          forFn(arr1, item.pid)
          break
        } else {
          if (item.children) {
            forFn(item.children, id)
          }
        }
      }
    }
    forFn(arr1, id)
    return temp
  }

  // 搜索
  searchHandle() {
    this.searchResult = [];
    if (this.searchValue) {
      this.searchResult = this.deptList.filter(item => item.title.indexOf(this.searchValue) != -1)
    }
  }

  // 取消搜索
  cancelSearchHandle() {
    this.searchResult = [];
    this.searchValue = null;
  }


  // 选择部门
  selectDeptHandle(dept: any) {
    this.cancelSearchHandle();
    const hasThis = this.resultList.some(item => item.value == dept.value);
    if (!hasThis) {
      if (this.resultList.length > 0) {
        const hasLastItem = this.deptList.some(item => item.value == this.resultList[this.resultList.length - 1].value)
        if (hasLastItem) { // 在最后的叶子节点上更换部门
          this.resultList.splice(this.resultList.length - 1, 1);
        }
      }
      this.resultList.push(dept);
      this.deptList.forEach(item => {
        item['selected'] = item.value == dept.value;
      })
      if (dept.children && dept.children.length > 0) {
        this.deptList = dept.children;
      }
    }

    this.setScrollTop();

  }

  // 在结果处更改部门
  selectResultDeptHandle(item: any, index: number) {
    if (index != this.resultList.length - 1) {
      this.deptList = item.children;
      this.resultList.length = index + 1;
      this.blTree(this.deptList, item.value);
    }

    this.setScrollTop();
  }

  // 设置数据源列表滚动条置顶
  setScrollTop() {
    setTimeout(() => {
      document.getElementsByClassName('tree-picker-comp')[0].getElementsByTagName('ul')[0].scrollTop = 0;
    }, 0)
  }
}
